import * as React from 'react';

/** TiniMeet wordmark: a sketch video-camera glyph + hand-lettered name with a highlighter swipe. */
export function Wordmark({ size = 30 }: { size?: number }) {
  return (
    <span className="wordmark" style={{ ['--wm-size' as any]: `${size}px` }}>
      <svg
        className="wordmark__cam"
        width={size * 1.25}
        height={size}
        viewBox="0 0 40 32"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M4 9 q-1 -3 3 -3 l15 0 q3 0 3 3 l0 14 q0 3 -3 3 l-15 0 q-3 0 -3 -3 z"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinejoin="round"
        />
        <path
          d="M28 12 l8 -4 q2 -1 2 2 l0 12 q0 3 -2 2 l-8 -4 z"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinejoin="round"
        />
        <circle cx="13" cy="16" r="3.4" fill="currentColor" />
      </svg>
      <span className="wordmark__text">
        Tini<span className="wordmark__hl">Meet</span>
      </span>
    </span>
  );
}
